import { IADPState, IHeaderState, Views} from "../types/AppStateInterface";
import { IADPActions, IADPHeaderActions } from "./Actions";
import * as actionTypes from "../types/ActionTypes";
import { AppConfigExtended } from '../types/Config'
import { Content } from "../types/Content";
import { Battery, StressTestState } from "../types";
import { ConnectionStateType, LanguageSwitchType } from "@npd-ng/adp-benchmark";
import { SessionDetails } from "../types/BridgeTypes";
import {DeviceMetricsService} from '../services/DeviceMetricsService';
import { indexDBStorage } from "../storage/indexDBStorage";
import { environment, isLocalhost } from "../util";
import pkgJSON from '../../../package.json';
import { postMessageToAdpBridge } from "../hooks/useIPCBridge";
import TimeService from "../services/TimeService";
import { ValidationResponseCheck, ValidationSummary } from "@npd-ng/adp-types";
export const initialHeaderState: IHeaderState = {
    networkConnectionState: ["WifiOff"],
    batteryState: "Danger",
    clockState: "",
    showBatteryWarning: false,
    selectedLocale: "en"
}

export const initialState: IADPState = {
    appState: {
        appLaunchId: undefined,
        appLaunchTime: new Date().toISOString(),
        appVersion: pkgJSON?.version,
        appCode: pkgJSON?.name,
        appBuildDate:undefined,
        releaseVersion: undefined,
        releaseBuildNumber: 0,
        environment: undefined,
        apiDomain: environment.resolveApiDomain(),
        configuration: undefined,
        currentView: "LoadingView",
        isPageReloaded: false,
        runtimePlatform: {
            platform: "Browser",
            version: "",
            userAgent: ""
        }
    },
    updateState: {
        isCheckForUpdateEnabled:true,
        appComponentVersions:[]
    },
    cacheValidation:{
        validationStatus: "NotStarted",
    },
    serviceWorkers:[],
    deviceState: {
        batteryState: undefined,
        battery: undefined,
        deviceId: undefined,
        deviceType: undefined,
        deviceModel: undefined,
        isDeviceHealthy: undefined,
        //@ts-ignore
        browserAgentData:{
            //@ts-ignore
            brands: navigator?.userAgentData?.brands,//@ts-ignore
            mobile:navigator?.userAgentData?.mobile,//@ts-ignore
            platform: navigator?.userAgentData?.platform //@ts-ignore
        }
    },
    sessionState: {
        selectedLanguage: TimeService.timeZone()=== "America/Puerto_Rico" ? "spanish" : "english",
        selectedAssessmentMode: "notselected",
        networkConnectionState: navigator?.onLine ? "online" : "offline",
        networkChangeEvents:[],
        serverConnectionState: undefined,
        schoolDetails: undefined,
        lastKnownGoodState: "LoadingView",
        providedSetupCode:undefined,
        selectedAssessmentLocation:undefined,
        locationError:false
    },
    deviceReadinessState: {
      validationState: undefined,
      validationError: undefined
    },
    deviceReadinessSummary:undefined,
    networkReadinessState: {
        isRequired: undefined,
        executionState: {
            state: "Pending",
            stressTestPassed: false
        }
    },
    staticContent: undefined
};
export function headerReducer(state: IHeaderState, action: IADPHeaderActions):IHeaderState{
    const logPrefix = "[ADPClient][HeaderAction]"
    console.log(logPrefix, action.type, action.payload)
    switch (action.type) {
        case actionTypes.SET_BATTERY:
        const batteryPyaload = action.payload as Battery
        return {
            ...state,
            batteryState: batteryPyaload.charging ?
                    "Charging" : batteryPyaload.level > 0.5 ?
                        "Full" : batteryPyaload.level < 0.3 ?
                            "Danger" : "Half",
            showBatteryWarning: batteryPyaload.charging ? false : batteryPyaload.level < 0.3 ? true : false
            }
    case actionTypes.SET_NETWORK:
        const networkPayload:ConnectionStateType = action.payload === "online" ? "Wifi" : action.payload === "router" ? "Router" : "WifiOff"
        
        return {
            ...state,
            networkConnectionState: [networkPayload]
        };
   case actionTypes.SET_LOCALE:
    return {
        ...state,
        selectedLocale: action.payload as unknown as LanguageSwitchType["selectedLocale"]
    };
    case actionTypes.SET_BATTERY_WARN:
    return {
        ...state,
        showBatteryWarning: false
    };
    default:
        return state;
    }
}
export function reducer(state: IADPState, action: IADPActions): IADPState {
    const logPrefix = "[ADPClient][ADPAction]"
    console.log(logPrefix, action.type, action.payload);
    let newStore = state;
    switch (action.type) {
        case actionTypes.SET_STRESS_TEST_ACTION: {
            const executionState: StressTestState = action.payload.state === "Completed" && !action.payload.stressTestPassed ? "Failed" : action.payload.state;
            const newState: IADPState= {
                ...state,
                networkReadinessState: {
                    ...state.networkReadinessState,
                    executionState: {
                        state: executionState,
                        stressTestPassed: action.payload.stressTestPassed,
                        stressTestSummary:action.payload.stressTestSummary
                    }
                    }
                }
            
                newStore = newState;
                break;
        }
        case actionTypes.UPDATE_NCS_STATE:{
            const newState: IADPState= {
                ...state,
                connectedNCSState: action.payload
                }
                newStore = newState;
                break;
            }
            case actionTypes.SET_APP_COMPONENT_VERSIONS:{
                const appComponentVersionArray = [...state.updateState.appComponentVersions];
                appComponentVersionArray.push(action.payload);
                const newState: IADPState= {
                    ...state,
                    updateState: {
                        ...state.updateState,
                        appComponentVersions: appComponentVersionArray
                    }                    }
                    newStore = newState;
                    break;
                }    
        case actionTypes.UPDATE_PRECACHE_VALIDATION_STATUS:{
            let events = [...state.cacheValidation?.validationEvents|| []];
            events.push(action.payload)
            const newStateV:IADPState = {
                ...state,
                cacheValidation:{
                    ...state.cacheValidation,
                    validationStatus: action.payload.validationStatus,
                    validationDetails: action.payload.validationDetails,
                    validationEvents:events
                },   
            }
            newStore = newStateV;
            break;  
        }
        case actionTypes.UPDATE_SERVICE_WORKER_DETAILS:{
            let serviceWorkers = [...state.serviceWorkers || []];
            const appComponentVersionArray = [...state.updateState.appComponentVersions];
            appComponentVersionArray.push({name:action.payload.appCode, version:action.payload.cachedVersion as string});
            if(state.serviceWorkers && state.serviceWorkers?.length > 0){
               const serviceWorker =  state.serviceWorkers.find((sw) => {
                return sw.appCode === action.payload.appCode 
            })
            const updatedSW = {...serviceWorker,...action.payload}
            serviceWorkers.push(updatedSW);
            }
            else {
                serviceWorkers.push(action.payload)
            }
            const newStateV:IADPState = {
                ...state,
                serviceWorkers: serviceWorkers,
                updateState: {
                    ...state.updateState,
                    appComponentVersions: appComponentVersionArray
                }    
                }
            newStore = newStateV;
            break;  
        }
        case actionTypes.UPDATE_DEVICE_VALIDATION_STATE:{
            const newStateV:IADPState = {
                ...state,
                deviceReadinessState: {
                    ...state.deviceReadinessState,
                    deviceReadinessInfo: action.payload
                },
            }
            newStore = newStateV;
            break;
        }
        case actionTypes.SET_DEVICE_READINESS_SUMMARY:{
            const newStateV:IADPState = {
                ...state,
                deviceReadinessSummary: state?.deviceReadinessSummary ? ({
                    deviceName: state.deviceState.deviceId || "NotAvailable",
                    status: state.deviceReadinessSummary.status || "Success",
                    responses:[...action.payload,...state.deviceReadinessSummary.responses] 
                } as ValidationSummary) : ({
                    deviceName: state.deviceState.deviceId || "NotAvailable",
                    status: "Success",
                    responses: [...action.payload]
                } as ValidationSummary)
            }
            newStore = newStateV;
            break;
        }
        case actionTypes.SET_ASSESSMENT_LOCATION:{
            const newStateV:IADPState = {
                ...state,
                sessionState:{
                    ...state.sessionState,
                    selectedAssessmentLocation: action.payload
                }
            }
            newStore = newStateV;
            break; 
        } 
        case actionTypes.SET_LOCATION_ERROR:{
            const newStateV:IADPState = {
                ...state,
                sessionState:{
                    ...state.sessionState,
                    locationError: action.payload
                }
            }
            newStore = newStateV;
            break;
        }
        case actionTypes.SET_BATTERY:
            const batteryPyaload = action.payload;
            const newState:IADPState = {
                ...state,
                deviceState: {
                    ...state.deviceState,
                    batteryState: batteryPyaload.charging ?
                    "Charging" : batteryPyaload.level > 0.5 ?
                        "Full" : batteryPyaload.level < 0.3 ?
                            "Danger" : "Half",
                    battery: {charging: batteryPyaload.charging, level: batteryPyaload.level}
                }
            }
            DeviceMetricsService().patchDeviceMetrics(newState);
            newStore = newState;
            break;
        case actionTypes.SET_NETWORK:{
            const networkPayload = action.payload
           const newStateV= {
                ...state,
              sessionState:
                {
                    ...state.sessionState,
                    networkConnectionState: networkPayload
                }
              
            };
            newStore = newStateV;
            break;
        }
        case actionTypes.SET_NETWORK_DETAILS:{
            const events = [...state.sessionState.networkChangeEvents];
            events.push(action.payload)
            const newStateV= {
                ...state,
                sessionState:
                {
                    ...state.sessionState,
                    networkDetails: action.payload,
                    networkChangeEvents: events
                } 
            };
            newStore = newStateV;
            break;
        }
 
        case actionTypes.SHOW_ERROR_ACTION:{
            const newState:IADPState = {
                ...state,
                 deviceReadinessState:{
                ...state.deviceReadinessState,
                validationError: action.payload
               },
               appState:{
                ...state.appState,
                currentView: "ErrorView"
               }
            }
            newStore = newState;
            break;
        }
           
        case actionTypes.SHOW_WARNING_ACTION:
          return {
                ...state,
                 deviceReadinessState:{
                ...state.deviceReadinessState,
                validationError: action.payload
               },
               appState:{
                ...state.appState,
                currentView: "WarningView"
               }
            }
        case actionTypes.SET_VALIDATION_ACTION:
            return {
                ...state,
               deviceReadinessState:{
                ...state.deviceReadinessState,
                validationState: action.payload
               }
            }   
        case actionTypes.UPDATE_SCHOOL:
            {
                let newState = {...state}
                if(action.payload === undefined){
                    newState ={
                        ...state,
                        sessionState:{
                            ...state.sessionState,
                            providedSetupCode:state.sessionState?.providedSetupCode,
                            schoolDetails: action.payload
                           },
                }
                }
                else{
                newState ={
                    ...state,
                    sessionState:{
                        ...state.sessionState,
                        providedSetupCode:action.payload?.setupCode,
                        schoolDetails: action.payload
                       },
                    }
                }
            newStore = newState;
            break;
        }

        case actionTypes.SET_ASSESSMENT_MODE:{
            const newState:IADPState= {
                ...state,
                sessionState:{
                    ...state.sessionState,
                    selectedAssessmentMode: action.payload,
                    lastKnownGoodState: action.payload === "notselected" ? "ModeSelectionsView" : "SetupCodeValidationView"
                   },
                   appState: {
                    ...state.appState,
                    currentView: action.payload === "notselected" ? "ModeSelectionsView" :"WaitView"
                }
            }
            newStore = newState;
            break;
        }
        case actionTypes.SET_VIEW:{
            console.log('action.payload',action.payload)
            const newState: IADPState= { 
                ...state,
                appState: {
                    ...state.appState,
                    currentView: action.payload
                },
                sessionState:{
                    ...state.sessionState,
                    lastKnownGoodState: ["ErrorView","WarningView","WaitView"].includes(action.payload) ? state.sessionState.lastKnownGoodState : action.payload
                   }
            }
            if(newState.appState.currentView === "ModeSelectionsView"){
                //reset the session state when returned to mode selection view
                newState.sessionState.selectedAssessmentMode = "notselected";
                newState.sessionState.providedSetupCode = undefined;
                newState.sessionState.serverConnectionState = undefined;
                newState.sessionState.schoolDetails = undefined;
            }
            newStore = newState;
            break;
        }
            
        case actionTypes.SET_CONFIG:{
            const payload = action.payload as AppConfigExtended
            const newState: IADPState= {
                ...state,
                appState: {
                    ...state.appState,
                    environment: payload.environment,
                    configuration:{
                        ...state.appState.configuration,
                        ...payload
                    }
                },
                networkReadinessState: {
                    ...state.networkReadinessState,
                    isRequired: false //TODO - introduce in config 
                },
               
            };
            newStore = newState;
            break;
        }

            case actionTypes.SET_RELEASE_VERSION: {
               const newState: IADPState= {
                    ...state,
                    appState: {
                        ...state.appState,
                        releaseVersion: action.payload.release.version,
                        releaseBuildNumber: action.payload.release.buildNumber,
                        configuration: {
                            ...state.appState.configuration as AppConfigExtended,
                            versionColors: action.payload.release.versionColors,
                            versionBorderColors: action.payload.release.versionBorderColors
                        }
                    },
                };
                newStore = newState;    
                break;
            }
               
        case actionTypes.SET_CONTENT:{
            const contentPyaload = action.payload as Content;
            const newState =  {
                ...state,
                staticContent: contentPyaload,
            };
        newStore = newState;    
        break;
        }
        case actionTypes.SET_SESSION_DETAILS: {
            const sessionDetails= action.payload as SessionDetails
            const getView =(): Views=>{
               const deviceValidationChecks =  sessionDetails.deviceValidationChecks;
               const failedChecks = deviceValidationChecks?.responses.filter(deviceValidationCheck => 
                !deviceValidationCheck.isCheckPassed && deviceValidationCheck.type === ValidationResponseCheck.HARD_CHECK);
                console.log("FailedCHecks are set to: ",failedChecks);
                
                if (failedChecks && failedChecks.length > 0){
                    const systemChecks = failedChecks?.filter(deviceValidationCheck => 
                        deviceValidationCheck.name.includes("checkStudentComponents"));
                    if(systemChecks.length>0){
                        console.log("System checks inside if:",systemChecks)
                        return "ErrorView";
                    }
                    else{
                        console.log("System checks inside else:",systemChecks)
                        return "HardwareCheckFailureView";
                    }
                    
                }
                else {
                    if((isLocalhost() || sessionDetails.networkConnectionState !== "online" )){
                        return "ModeSelectionsView"
                    }
                    else{
                        return state.appState.currentView
                    }
                    
                }
            }
            const newState: IADPState = {
                ...state,
                cacheValidation:{
                    ...state.cacheValidation,
                    validationStatus:!isLocalhost() && sessionDetails.networkConnectionState === "online" ? "InProgress" :  "Complete",
                    validationDetails:!isLocalhost() && sessionDetails.networkConnectionState === "online" ? 
                    "Initiating service worker validation": "Skip service worker validation",
                },
               appState:{
                ...state.appState,
                appLaunchId:sessionDetails.appLaunchId,
                releaseVersion: sessionDetails.releaseVersion || state.appState.releaseVersion,
                environment: sessionDetails.environment,
                runtimePlatform: sessionDetails.runtimePlatform,
                currentView: getView(), 
                isPageReloaded: sessionDetails.isPageReloaded
               }, 
               sessionState:{
                ...state.sessionState,
                lastKnownGoodState:getView(),
                networkConnectionState: sessionDetails.networkConnectionState ? sessionDetails.networkConnectionState : state.sessionState.networkConnectionState
               },
               deviceReadinessSummary:sessionDetails.deviceValidationChecks,
                deviceState:{
                    ...state.deviceState,
                    deviceId: sessionDetails.deviceId,
                    deviceModel: sessionDetails.deviceModel,
                    deviceType: sessionDetails.deviceType,
                    systemInfo: sessionDetails.systemInfo
                },
                updateState: {
                    ...state.updateState,
                    isCheckForUpdateEnabled: sessionDetails.isCheckForUpdateEnabled || false
                }
              
            }; 
            newStore = newState;
            (async () => {
                const instance =  await indexDBStorage.getInstance();
                console.log("appState.appState.appLaunchId",newStore.appState.appLaunchId)
                instance.transactions.put("adp-session-references",newStore.appState.appLaunchId,"clientLaunchId")
              })().catch(err => {
                  console.error(err);
              });
            break;
        }
           
         case actionTypes.SET_UPDATE_PROGRESS:{
            const newState:IADPState = {
                ...state,
                updateState:{
                    ...state.updateState,
                    updateEvents: action.payload
                }
            } ;
            newStore = newState;
            break;    
         }
               
        default:
            return state;
    }
    //store in indexDB
    
    indexDBStorage.getInstance().then((instance)=>{
        if(!newStore.appState.appLaunchId) return;
        const storeToPersist = {
          clientLaunchId: newStore.appState.appLaunchId,
          appState: newStore.appState,
          cacheState: {...newStore.serviceWorkers,...newStore.cacheValidation},
          deviceReadinessState: {...newStore.deviceReadinessState,deviceValidationSummary:newStore.deviceReadinessSummary},
          deviceState: newStore.deviceState,
          stressTestResults: newStore.networkReadinessState,
          sessionState: newStore.sessionState,
          updateState: newStore.updateState,
          ncsState: newStore.connectedNCSState
        }
        /**
         * store pwa state in IndexDB under the eNAEP domain
         * e.g npd-ng-adp-storage-v2 - https://enaep.dev24.npdng.org/
         * Environment specific storages will be created
         */
        instance.transactions.put("adp-state-indexed",storeToPersist);
         /**
         * post adp pwa stat to chrome extension to persist in indexDB under the Chrome extension domain
         * e.g npd-ng-adp-storage-v2 - chrome-extension://cmgaklaggiapjhkgfehhcgbgilogdmmm/
         * Chrome extension will take care of posting the diagnostic data in NCS mode
         */
        postMessageToAdpBridge({
            type: "PostChromeAppState",
            data: storeToPersist
          });
       });
      return newStore;
}

